import React from "react";
import FormWrapper from "../../ServeToThrive/shared/FormWrapper";
import ProgressBar from "../../ServeToThrive/shared/ProgressBar";

const refereeRoleOptions = [
  { value: "pastor", label: "Pastor" },
  { value: "elder", label: "Elder" },
  { value: "leader", label: "Leader" },
  { value: "deacon", label: "Deacon" },
  { value: "member", label: "Member" },
  { value: "other", label: "Other" },
];

const inputStyle = {
  width: "100%", padding: "12px 16px", fontSize: "16px", color: "#1a1a1a",
  backgroundColor: "#fff", border: "1px solid #e5e5e5", borderRadius: "8px",
  outline: "none", transition: "all 0.2s ease", boxSizing: "border-box",
};

export default function Reference({ formData, onInputChange, onContinue, onBack, stepNumber, totalSteps, submitting }) {
  const isValid =
    formData.refereeName?.trim() &&
    formData.refereeEmail?.trim() &&
    formData.refereeRole;

  const focusStyle = (e) => { e.currentTarget.style.borderColor = "#1a1a1a"; e.currentTarget.style.boxShadow = "0 0 0 3px rgba(26,26,26,0.05)"; };
  const blurStyle = (e) => { e.currentTarget.style.borderColor = "#e5e5e5"; e.currentTarget.style.boxShadow = "none"; };

  return (
    <FormWrapper>
      <button onClick={onBack} style={{ display: "flex", alignItems: "center", gap: "6px", padding: "8px 12px", fontSize: "14px", fontWeight: "500", color: "#737373", backgroundColor: "transparent", border: "none", cursor: "pointer", marginBottom: "8px" }}
        onMouseEnter={(e) => (e.currentTarget.style.color = "#1a1a1a")}
        onMouseLeave={(e) => (e.currentTarget.style.color = "#737373")}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6" /></svg>
        Back
      </button>

      <ProgressBar currentStep={stepNumber} totalSteps={totalSteps} />

      <div style={{ textAlign: "center", marginBottom: "32px", animation: "fadeInUp 0.5s ease" }}>
        <div style={{ width: "48px", height: "48px", backgroundColor: "#f3f4f6", borderRadius: "12px", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px", border: "1px solid #e5e7eb" }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#36454F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" />
            <path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>
        </div>
        <h1 style={{ fontSize: "24px", fontWeight: "700", color: "#1a1a1a", marginBottom: "8px", letterSpacing: "-0.5px" }}>Church reference</h1>
        <p style={{ fontSize: "15px", color: "#737373", margin: 0, lineHeight: "1.5" }}>
          Provide a reference from your church community to verify your profile.
        </p>
      </div>

      <div style={{ padding: "16px", backgroundColor: "#f3f4f6", borderRadius: "8px", marginBottom: "24px", border: "1px solid #e5e7eb", animation: "fadeInUp 0.5s ease 0.1s both" }}>
        <p style={{ fontSize: "13px", color: "#36454F", margin: 0, lineHeight: "1.5" }}>
          We'll send your reference an email to confirm they know you. Your profile will become visible to others once they confirm.
        </p>
      </div>

      {[
        { field: "refereeName", label: "Referee's full name", type: "text", placeholder: "E.g., John Smith" },
        { field: "refereeEmail", label: "Referee's email", type: "email", placeholder: "referee@example.com" },
      ].map(({ field, label, type, placeholder }) => (
        <div key={field} style={{ marginBottom: "16px", animation: "fadeInUp 0.5s ease 0.15s both" }}>
          <label style={{ display: "block", fontSize: "14px", fontWeight: "600", color: "#1a1a1a", marginBottom: "8px" }}>
            {label} <span style={{ color: "#dc2626" }}>*</span>
          </label>
          <input type={type} value={formData[field] || ""} onChange={(e) => onInputChange(field, e.target.value)}
            placeholder={placeholder} style={inputStyle} onFocus={focusStyle} onBlur={blurStyle} />
        </div>
      ))}

      <div style={{ marginBottom: "32px", animation: "fadeInUp 0.5s ease 0.3s both" }}>
        <label style={{ display: "block", fontSize: "14px", fontWeight: "600", color: "#1a1a1a", marginBottom: "8px" }}>
          Referee's role at church <span style={{ color: "#dc2626" }}>*</span>
        </label>
        <select value={formData.refereeRole || ""} onChange={(e) => onInputChange("refereeRole", e.target.value)}
          style={{ ...inputStyle, color: formData.refereeRole ? "#1a1a1a" : "#a3a3a3", cursor: "pointer" }}
          onFocus={focusStyle} onBlur={blurStyle}>
          <option value="">Select their role...</option>
          {refereeRoleOptions.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      </div>

      <button onClick={onContinue} disabled={!isValid || submitting}
        style={{ width: "100%", padding: "16px 24px", fontSize: "16px", fontWeight: "600", color: "#fff", backgroundColor: isValid && !submitting ? "#1a1a1a" : "#d4d4d4", border: "none", borderRadius: "8px", cursor: isValid && !submitting ? "pointer" : "not-allowed", transition: "all 0.2s ease", display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}
        onMouseEnter={(e) => { if (isValid && !submitting) { e.currentTarget.style.backgroundColor = "#333"; e.currentTarget.style.transform = "translateY(-1px)"; } }}
        onMouseLeave={(e) => { if (isValid && !submitting) { e.currentTarget.style.backgroundColor = "#1a1a1a"; e.currentTarget.style.transform = "translateY(0)"; } }}>
        {submitting ? "Submitting..." : "Submit"}
        {!submitting && <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></svg>}
      </button>
    </FormWrapper>
  );
}
